import './App.css';
 
 
import FsRouter from './components/element/FsRouter.js'

import FsWinManager from './components/render/FsWinManager.js'

import {
	Menu,
	Dropdown,
	Spin
} from '@jd/find-react';


import {
	IconFont
} from '@jd/find-react';


import React from 'react';
 
import KeeVue from './components/base/KeeVue.js'

import FsView from './components/render/FsView'
 
import KinerGuideView from './KinerGuide/KinerGuideView.js'

import $ from 'jquery';


class FsPreView extends KeeVue {
	constructor(props) {
		super(props);
		this.state = {
			appId: '2021031708594945141281972480-CSY',
			code: 'cityDriverInfo/',

			keePage: null,
			components: [],
			component: {
				cp: {}
			},
			activeComponent: null,
			controller: {
				showSource: false,
				vueSource: "",
			},
			fsViewPageUrl: '',

			currentUrl: '',
			showReact: false,
			vueJsArray: [],
			vueloadedCount: 0,
			loadUrlinfo: '',
			loadUrlinfo2: '',
			mainInfo: null,
			clientConfig: {}
		}

		this.myRef = React.createRef();

	}
 
	// 处理路由监听的问题

	doUrlListen() {

		window.onpopstate = function(state, title, url) {
			alert("onpopstate" + url);
		}


	}

	componentWillMount() {

		window.showMainFrame = true;

		this.fileCount = 3;
		
		 
	  

		var url = window.rootWebPath + "/clientConfig/getMap";
		// var url = window.location.protocol+"//"+window.location.host+"/clientConfig/getMap";
		if (process.env.NODE_ENV == 'development') {
			window.rootUri = window.webUrl;
			url = window.webUrl + "/clientConfig/getMap";
		} else {
			window.rootUri = window.rootWebPath;
		}


		// this.onEvent("HashChange",(url,params)=>{
		// 	// 

		// 	//alert("mainMenu的hashchange收到事件"+url);
		// 	this.openHashSp(url,params);
		// 	this.$emit("HashChange",url,params);

		// });



		// 加载京智办的sdk

		this.doRequest(url, (ret) => {


			if (ret) {
				window.tid = ret.tid;
				window.keyName = ret.keyName;


				// window.rootUri = ret.rootWebPath;
				window.rootClientWebPath = window.rootWebPath;

				window.ClientInsConfig = ret;

				window.ServerConfig = ret;

				if (ret && ret.gloabalMap) {
					for (let p in ret.gloabalMap) {
						if(process.env.NODE_ENV=='development'&&p=="webUrl")
						{
							continue;
						} 
						window[p] = ret.gloabalMap[p];
					}


				}
				window.clientMap = ret;
				window.SERVER = ret;

				//如果是网站预览模式，keyNam设置为空
				if (window.appCode) {
					window.keyName = "";

					if (window.webKeyName) {
						window.keyName = window.webKeyName;
					}
				}
			}


			this.init(url, ret);


			return;



		});



		console.log("mount执行一次定时任务：")


	}


	openHashSp = (sp, pdata) => {

		// 参数处理

		var params = "";
		var url = window.location.href;

		var urls = url.split("?");

		var existsSp = false;
		if (!existsSp) {
			if (params) {
				params = "sp=" + sp + "&" + params;
			} else {
				params = "sp=" + sp;
			}

		}

		if (pdata && typeof pdata != 'string' && typeof pdata == 'object') {
			for (var p in pdata) {
				params += "&" + p + "=" + pdata[p];
			}
		}



		window.history.pushState({
			sp: sp
		}, "", "?" + params);

		// 触发一次变更，fs-view 修改了当前url，通过值的绑定来更新
		//this.onHashChange();

	}


	init = (url, ret) => {

		this.beginInit = true;

		this.fileCount = 3;



		this.state.loadUrlinfo = "/clientConfig/getMap";
		// this.doRequest(url,(ret)=>{

		this.state.loadUrlinfo = "/clientConfig/getMap-ok";
		this.refresh();

		this.state.clientConfig = ret;

		// 设置feasApp的样式

		$("#feasApp").addClass(ret.mainClassName);
		$("#win-manager-div").addClass(ret.mainClassName);


		this.vueJsArray = [];

		window.disableVue = ret.disableVue;


		let protocolStr = document.location.protocol;
		if (protocolStr == "https:") {
			window.rootUri = window.rootUri.replace("http://", "https://");
		} else {
			window.rootUri = window.rootUri.replace("https://", "http://");
		}

		// 加载Vue的js资源文件
		// this.vueJsArray.push(window.rootUri+"/mainFrame/config?_t=4.20210825102000");
		// this.vueJsArray.push(window.rootUri+"/keePage/getAllPropForm?_t=4.20210825102000&tid="+window.tid+"&keyName="+window.keyName+"&code=common-component");
		if (!ret.disableVue) {
			
			let  vueFileNames = "";
			vueFileNames += "kee-string.vue"; 
			vueFileNames += ",fs-icon.vue,fs-alert.vue,fs-pic-select.vue,fs-table-tree.vue"; 
			vueFileNames += ",fs-tree.vue,fs-table.vue,fs-table-col.vue,"; 
			vueFileNames += "fs-dropdown.vue,fs-select.vue,fs-cascader.vue,fs-upload.vue,fs-ztree.vue,fs-scroll.vue"; 
			vueFileNames += ",fs-layout.vue,fs-tree-menu.vue,fs-text.vue,fs-button.vue,fs-view.vue"; 
			vueFileNames += ",fs-pic.vue,fs-video.vue,fs-rect.vue,fs-form.vue,fs-tabs.vue,feas-page.vue,";
			vueFileNames += ",fs-dialog.vue,fs-border-layout.vue,";
			vueFileNames+= "fs-list.vue,fs-menu-item.vue,fs-win-manager.vue,"; 
			vueFileNames+= "fs-box.vue,fs-card.vue,fs-color.vue,fs-code-editor.vue,fs-html-editor.vue";
				
				
				
				 
					if(window.location.host.indexOf("cms.xjoycity.com")!=-1)
					{
						let vueJs = vueFileNames.split(",");
						for(let item of vueJs)
						{
							if(item)
							{
								console.log("jiazai:"+window.rootWebPath+"/front/_vue/"+item.replace(".vue",".js")+"?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
									this.vueJsArray.push(window.rootWebPath+"/front/_vue/"+item.replace(".vue",".js")+"?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
								
							}
						}
						
					}
					else
					{
						// this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
						
						this.vueJsArray.push(window.rootUri+"/vResList/getByCombineJs?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
						
					}
					


			// this.vueJsArray.push(window.rootUri + "/api/vueComponentJs/getByCombineJs?_t=" + window
			// 	.PLATFORM_BUILD_VERSION + "&tid=" + window.tid + "");
			// this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t=4.20210825102000&tid="+window.tid+"");
			//to	this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getServerBusinessJs?_t=4.20210825102000&tid="+window.tid+"");
			//this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/fsInput?_t=4.20210825102000&tid="+window.tid+"");
			this.vueJsArray.push(window.rootWebPath + "/front/fs-input.js?_t=" + window.BUILD_VERSION + "&tid=" +
				window.tid + "");
			this.vueJsArray.push(window.rootWebPath + "/front/fs-render.js?_t=" + window.BUILD_VERSION + "&tid=" +
				window.tid + "");
			// this.vueJsArray.push("/front/fs-input-nutui.js?_t=4.20210825102000&tid="+window.tid+"");
			this.fileCount = this.vueJsArray.length;

		}
		// this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t=4.20210825102000&tid="+window.tid+"");
		// this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t=4.20210825102000&tid="+window.tid+"");
		// this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getServerBusinessJs?_t=4.20210825102000&tid="+window.tid+"");
		//this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/fsInput?_t=4.20210825102000&tid="+window.tid+"");
		// this.vueJsArray.push("/front/fs-input.js?_t=4.20210825102000&tid="+window.tid+"");
		// this.vueJsArray.push("/front/fs-render.js?_t=4.20210825102000&tid="+window.tid+"");
		// this.vueJsArray.push("/front/fs-input-nutui.js?_t=4.20210825102000&tid="+window.tid+"");


		if (window.clientMap && window.clientMap.customCssUrl) {
			let cssUrls = window.clientMap.customCssUrl.split(",");
			this.fileCount += cssUrls.length;
		}



		this.state.loadUrlinfo = "/mainFrame/getMainInfo";
		this.refresh();

		let appCodeUrl = this.getUrlParameter("appCode");

		window.isReport = appCodeUrl.indexOf("REPORT_") == 0

		// 然后获取用户信息，如果获取成功显示，如果获取失败，跳转到登录页面

		this.doRequest("/mainFrame/getMainInfo", (mainInfo) => {

			this.state.loadUrlinfo = "/mainFrame/getMainInfo-ok" + mainInfo.success;
			this.refresh();
			var fromShort = this.getUrlParameter("from");

			// alert("window.isMp:"+window.isMp);
			//alert(JSON.stringify(mainInfo));
			if ((mainInfo.success || window.appCode) && fromShort != 'short') {

				// window._sign = mainInfo.retData._sign;
				// window._publicKey = mainInfo.retData.publicKey;
				// window._rsakey = mainInfo.retData.rsakey;
				window.mainInfo = mainInfo;
				if (mainInfo && mainInfo.retData) {
					window.currentUserId = mainInfo.retData.currentUserId;
				}


				// 获取成功
				this.state.mainInfo = mainInfo.retData;
				window.document.title = mainInfo.retData.systemTitle;
				console.log("window.document.title:" + mainInfo.retData.systemTitle);
				//this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);

		 
				
				if(ret.tabIcon)
				{
					this.selfSetIcon(ret.tabIcon);
				}
				else
				{
					if(this.state.mainInfo.sys.icon)
					{
						this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.icon);
					}
					else
					{
						this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
					}
					 
				}

				//alert(JSON.stringify(this.state.mainInfo));
				this.startLoadApp(ret);
			} else {
				//如果是在京智办里面，则直接获取code进行登录操作，如果登录失败，则跳转到登录页面
				this.state.loadUrlinfo = "/mainFrame/getMainInfo-ok2" + mainInfo.success;
				this.refresh(); 

				if (this.getUrlParameter("from") == "short") {
					this.startLoadApp(ret);

					return;
				}

			}


			this.refresh();

			this.beginRefresh();

		})
		// })

	}

	beginRefresh = () => {

		console.log("refresh mainframe")
		this.refresh();
		if (!this.stopRefresh) {
			setTimeout(
				this.beginRefresh, 1000);
		}
	}

	doMainInfo = (mainInfo, ret) => {


		this.state.loadUrlinfo = "/getMainInfo-ret" + mainInfo.success;
		this.refresh();
		//alert(JSON.stringify(mainInfo));

		var fromShort = this.getUrlParameter("from");

		 
		//alert(JSON.stringify(mainInfo));
		if (mainInfo.success || window.appCode) {
			// window._sign = mainInfo.retData._sign;
			// window._publicKey = mainInfo.retData.publicKey;
			// window._rsakey = mainInfo.retData.rsakey;

			// 获取成功
			this.state.mainInfo = mainInfo.retData;
			window.document.title = mainInfo.retData.systemTitle;
			console.log("window.document.title222:" + mainInfo.retData.systemTitle);


			if (mainInfo && mainInfo.retData) {
				for (let p in mainInfo.retData) {
					if (p == 'allDicts' || p == "userPermissions") {
						window[p] = JSON.parse(mainInfo.retData[p]);
					} else {
						window[p] = mainInfo.retData[p];
					}
				}
			}


 
			
			if(ret.tabIcon)
			{
				this.selfSetIcon(ret.tabIcon);
			}
			else
			{
				if(this.state.mainInfo.sys.icon)
				{
					this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.icon);
				}
				else
				{
					this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
				}
				 
			}
			


			// 增加用户自定义的css
			if (window.clientMap && window.clientMap.customCssUrl) {

				let cssUrls = window.clientMap.customCssUrl.split(",");

				for (let ii = 0; ii < cssUrls.length; ii++) {
					let cssUrl = cssUrls[ii];
					if (cssUrl.indexOf("http") != 0) {
						cssUrl = window.rootUri + cssUrl;
					}
					
					if(cssUrl.indexOf("?")==-1)
					{
						cssUrl+="?";
					}
					cssUrl+="&pt="+window.MAX_KEE_PAGE_TIME;

					$.ajax({
						url: cssUrl,
						cache: true,
						type: 'get',
						dataType: "html",
						data: {},
						success: (str) => {

							this.state.vueloadedCount++;
							var nod = document.createElement("style");
							nod.type = "text/css";
							if (nod.styleSheet) { //ie下  
								nod.styleSheet.cssText = str;
							} else {
								nod.innerHTML =
									str; //或者写成 nod.appendChild(document.createTextNode(str))  
							}
							//document.getElementsByTagName("head")[0].appendChild(nod);

							document.body.parentNode.appendChild(nod);
							this.refresh();

						},
						error: function(XMLHttpRequest, textStatus, errorThrown) {

							console.log("网络请求错误getByAppBusinessCss");
							module.data = "";
						}
					});
				}


			}



			//alert(JSON.stringify(this.state.mainInfo));
		} else {
			//如果是在京智办里面，则直接获取code进行登录操作，如果登录失败，则跳转到登录页面


			{
				var fromPlatform = this.state.clientConfig.fromPlatform;

				if (!fromPlatform) {
					fromPlatform = "";
				}
				//debugger;
				var loginUrl = ret.passportUrl + "/login?fromPlatform=" + fromPlatform + "&tid=" + ret.tid +
					"&keyName=" + ret.keyName;
				loginUrl += "&returnUrl=" + window.location.href;
				window.location.href = loginUrl.replace("http:", document.location.protocol);
				return;
			}

		}
		this.state.loadUrlinfo = "kaishiload";
		this.refresh();

		// 计算页面的URL信息
		let pageCode = this.getUrlParameter("pageCode");
		let appName = this.getUrlParameter("appName");

		let spUrl = this.getUrlParameter("sp");
		if (spUrl) {
			//以sp的值为准
			if (spUrl.indexOf("20") == 0) {
				spUrl = spUrl.substring(spUrl.indexOf("M::"));
			}
			spUrl = spUrl.replace("M::", "");
			if (spUrl.indexOf("/") != -1) {
				if (spUrl.split("/")[0]) {
					appName = spUrl.split("/")[0];
				}
				if (spUrl.split("/")[1]) {
					pageCode = spUrl.split("/")[1];
				}
			}
		}

		let pageUrl = "M::" + appName + "/" + pageCode;

		this.onHashChange(pageUrl, {});
		
		this.fileCount++;

		this.vueJsArray.map((item, index) => {
			this.state.loadUrlinfo = "" + item;
			this.refresh();
			this.loadJs(item, () => {
				this.state.vueloadedCount++;
				this.refresh();
				this.showVueViewUrl(pageUrl);


				window.tid = ret.tid;
				window.keyName = ret.keyName;
				// window.rootUri = ret.rootWebPath;
				window.rootClientWebPath = window.rootWebPath;

				let protocolStr = document.location.protocol;
				if (protocolStr == "https:") {
					window.rootClientWebPath = window.rootClientWebPath.replace("http://",
						"https://");
					window.rootUri = window.rootUri.replace("http://", "https://");
				}

			});
		})
		
		if(window.clientMap.thirdLibs)
		{
			for(let i=0;i<window.clientMap.thirdLibs.length;i++)
			{
				console.log("load lib:"+window.clientMap.thirdLibs[i].url);
				if(window.clientMap.thirdLibs[i].name=='js')
				{
					this.loadJs(window.clientMap.thirdLibs[i].url,()=>{
						console.log("finish url:"+window.clientMap.thirdLibs[i].url);
					});
				}
				if(window.clientMap.thirdLibs[i].name=='css')
				{
					this.loadCss(window.clientMap.thirdLibs[i].url,()=>{
						console.log("finish url:"+window.clientMap.thirdLibs[i].url);
					});
				}
				
				if(window.clientMap.thirdLibs[i].name=='woff2'||window.clientMap.thirdLibs[i].name=='woff')
				{ 
					let content = "";
					content +="@font-face {  ";
					content +="    font-family: '"+window.clientMap.thirdLibs[i].title+"';  ";
					content +="    src: url('"+window.clientMap.thirdLibs[i].url+"') format('"+window.clientMap.thirdLibs[i].name+"');"; 
					content +="    font-weight: normal;  ";
					content +="    font-style: normal;  ";
					content +="}"; 
					let style = document.createElement('style');   
					// 为style元素添加CSS内容  
					style.innerHTML =  content; 
					// 将style元素添加到head元素中  
					document.head.appendChild(style); 
				}
				
			}
		}
		

		let protocolStr = document.location.protocol;
		if (protocolStr == "https:") {
			window.rootUri = window.rootUri.replace("http://", "https://");
		}


		// this.loadCss(window.rootUri + "/api/vueComponentJs/getByCombineCss?_t=4.20210825102000&tid=" + window.tid +
		// 	"", () => {
		// 		console.log("done:css");
		// 		this.state.vueloadedCount++;
		// 		this.showVueViewUrl(pageUrl);
		// 		this.refresh();

		// 	});

		// this.loadCss(window.rootUri+"/api/vueComponentJs/getByAppBusinessCss?_t=8&tid="+window.tid+"",()=>{

		// 	console.log("done:css");
		// 	this.state.vueloadedCount++;
		// 	this.showVueViewUrl("");
		// 	this.refresh();

		// });
		// this.state.vueloadedCount++;
		$.ajax({
			url: window.rootUri + "/api/vueComponentJs/getByAppBusinessCss?pt=" + window.MAX_KEE_PAGE_TIME +
				"&tid=" + window.tid,
			cache: true,
			type: 'get',
			dataType: "html",
			data: {},
			success: (str) => {

				this.state.vueloadedCount++;
				var nod = document.createElement("style");
				nod.type = "text/css";
				if (nod.styleSheet) { //ie下  
					nod.styleSheet.cssText = str;
				} else {
					nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))  
				}
				//document.getElementsByTagName("head")[0].appendChild(nod);

				document.body.parentNode.appendChild(nod);
				this.refresh();

			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {

				console.log("网络请求错误getByAppBusinessCss")
				module.data = "";
			}
		});






		this.refresh();


	}

	startLoadApp = (ret) => {




		this.state.loadUrlinfo = "/getMainInfo";
		this.refresh();
		// 然后获取用户信息，如果获取成功显示，如果获取失败，跳转到登录页面

		if (window.mainInfo && window.mainInfo.success) {
			this.doMainInfo(window.mainInfo, ret);
		} else {
			this.doRequest("/mainFrame/getMainInfo?_t=2", (mainInfo) => {
				this.doMainInfo(mainInfo, ret);
			})
		}




	}




	onHashChange = (url, node) => {
		console.log("onHashChange执行一次定时任务：" + url + (!this.beginInit || this.state.vueloadedCount != (this
			.fileCount) || !this.state.mainInfo))
		console.log("onHashChange执行一次定时任务：", this.beginInit, this.state.vueloadedCount, this.fileCount, this.state
			.mainInfo);

		if (url) {
			if (url.indexOf("jdccApp/") != -1) {
				node = {
					attributes: {
						appType: "vue"
					}
				}
			}

			if (url.indexOf("REPORT_") != -1) {
				node = {
					attributes: {
						appType: "React"
					}
				}
			}

			if (url.indexOf("jzbFormTianbao") != -1) {
				node = {
					attributes: {
						appType: "vue"
					}
				}
			}

		}

		if (!node) {
			node = this.currentNode;
		}

		this.currentNode = node;

		// 先暂时屏蔽，看看有没有什么问题
		if (url.indexOf("2021_") != -1) {
			url = url.substring(url.indexOf("2021_") + 5);
		}

		if (url.indexOf("2018_") != -1) {
			url = url.substring(url.indexOf("2018_") + 5);
		}




		if (!this.beginInit || this.state.vueloadedCount != (this.fileCount) || !this.state.mainInfo) {
			setTimeout(() => {
				this.onHashChange(url, node);
			}, 300);
			return;
		}

		// console.log("node.attributes.appType："+node.attributes.appType);
		// console.log("window.showReact"+window.showReact)

		// 判断node 是否是一个参数！
		let showReact = this.getUrlParameter("showReact")


		if (!showReact) {

			console.log("111");
			// 看看vue资源加载好了没有 
			this.state.showReact = false;
			window.showReact = false;
			// 让vue的版本去渲染页面
			if (window.mainVueApp) {
				console.log("222");
				// window.mainVueApp.currentUrl = url
				window.mainVueApp.sendEvent("vueCurrentUrl",url,node);

				this.showVueViewUrl(url);
			} else {
				console.log("333");
				window.vueCurrentUrl = url;
				//window.mainVueApp.sendEvent("vueCurrentUrl",url);
				this.showVueViewUrl(url);
			}
			$("#feasApp").show();
			this.state.currentUrl = "";
		} else {
			this.state.pageParameters = node;
			this.state.showReact = true;
			window.showReact = true;
			this.state.currentUrl = url;
			$("#feasApp").hide();
		}

		this.sendEvent("hashRefresh");


		this.refresh();
	}

	showVueViewUrl = (url) => {

		console.log("showVue执行一次定时任务：" + url)

		if (this.timerSvv) {
			clearTimeout(this.timerSvv);
		}
		this.timerSvv = null;

		let that = this;

		console.log("showVue执行一次定时任务：this.state.vueloadedCount=" + this.state.vueloadedCount+"=="+this.fileCount)
		if (this.state.vueloadedCount == (this.fileCount)&& typeof window.KeeVue=='function') {

			if (!window.mainVueApp && !this.beginLoadVue) {
				this.beginLoadVue = true;
				//  window.mainVueApp.sendEvent("vueCurrentUrl",url);
				setTimeout(() => {
					if (window.loadVueApp) {
						console.log("loadVueApp执行一次定时任务：");
						window.loadVueApp();
						that.refresh();
					}
				}, 100);



			}
		}


		if (window.mainVueApp) {
			console.log("showVue执行一次定时任务：window.mainVueApp=" + true + " window.showReact=" + window.showReact);

			if (window.showReact == false) {
				console.log("sendEvent执行一次定时任务：", window.showReact)

				if (this.state.vueloadedCount == (this.fileCount)) {
					//alert("触发事件")
					window.mainVueApp.sendEvent("vueCurrentUrl", url);

					this.refresh();
				}

			}

		} else {
			console.log("showVue执行一次定时任务：yanshi 300=" + true)
			// setTimeout(()=>{
			// 	 this.showVueViewUrl(url); 
			// },100)

			if (!this.timerSvv) {
				this.timerSvv = setTimeout(() => {

					console.log("执行一次定时任务：")
					this.showVueViewUrl(url);
				}, 300)
			}

		}
	}

	onClickChangePassword = (key) => {


	}
	onClickLogout = () => {}


	render() {

		var fullPage = this.getQueryVariable("fullPage");

		// 前端自适应https的问题
		if (window.fileUrl) {
			window.fileUrl = window.fileUrl.replace("http:", document.location.protocol);
			window.fileUrl = window.fileUrl.replace("https:", document.location.protocol);

		}



		if (this.state.clientConfig.jzbFullPage) {
			if (window.JZB_JSSDK && window.JZB_JSSDK.login) {
				fullPage = 1;
			}
		}

		fullPage = true;

		if (fullPage) {
			$("#feasApp").css("left", "20px");
			$("#feasApp").css("top", "20px");
			$("#feasApp").css("right", "20px");
			$("#feasApp").css("bottom", "20px");
			$("#feasApp").css("z-index", 1001);

			$("#feasApp").addClass("fullPage");
		}

		$("#feasApp").addClass("fspreview");

		var fromShort = this.getUrlParameter("from");



		if (this.beginInit && this.state.mainInfo && this.state.vueloadedCount == (this.fileCount)) {

			this.stopRefresh = true;

			let mainClassName = this.state.clientConfig.mainClassName;

			return (

				<div className = {
					`${mainClassName}`
				}
				style = {{
						background: '#ffffff',
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						display: (!this.state.showReact && fullPage ? 'none' : 'block')
					}} >



				{
					this.state.showReact && <div className = "feasApp-react-main-view"
					style = {{
							position: 'absolute',
							top: (0),
							left: (0),
							bottom: 0,
							right: '0',
							zIndex: (220),
							overflow: 'auto',
							display: (true ? 'block' : 'none')
						}} >
					<FsView minWidth = {
						window.isMobile ? '0' : '1200px'
					}
					url = {
						this.state.currentUrl
					}
					parameters = {
						this.state.pageParameters
					}
					keepAlive = {
						true
					}
					debug = {
						false
					}
					isHiddenScroll = {
						false
					} > </FsView></div>}	

					<div style = {{
							display: (this.state.showReact ? 'block' : 'none')
						}} >
					<FsWinManager> </FsWinManager> </div >

					<KinerGuideView guideStep = {0}	/>

					<FsRouter onHashChange = {
						this.onHashChange
					} > </FsRouter>


					</div> 
				);
			}
			else {
				// if("short"==fromShort)
				// {
				return <div style = {{
							width: '100%',
							height: '100%',
							textAlign: 'center',
							paddingTop: '300px'
						}} >

					{
						this.state.loadUrlinfo2 ? < span > {
							this.state.loadUrlinfo2
						} < /span>:<Spin tip={""}>  </Spin >
					}


					</div>
				// }
				// else
				// {
				// 	return <div style={{width:'100%',height:'100%',textAlign:'center',paddingTop:'300px'}}>
				// 	{this.state.loadUrlinfo2?<span>{this.state.loadUrlinfo2}</span>:<Spin tip={this.state.loadUrlinfo}>
				// 	 </Spin>}</div>
				// }


			}

		}

	}

	export default FsPreView;
